import React from 'react';
import TablaMultaObstruccion from './Tablas/TablaMultaObstruccion';
import GraficoMultaObstruccion from './Graficos/GraficoMultaObstruccion';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasMultaObstruccionDashboard from './Dashboard/ObrasMultaObstruccionDashboard';

const ObrasMultaObstruccion: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Multa por Obstrucción
      </Heading>
      <ObrasMultaObstruccionDashboard/>
      <TablaMultaObstruccion />
      {/* <GraficoMultaObstruccion /> */}
    </VStack>
  );
};

export default ObrasMultaObstruccion;
